export default __webpack_public_path__ + "media/images/mailer-new/common/header-bg-end-db72c62242f576f430f247482e4d4d27.png";